import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import HomePage from "./pages/HomePage.jsx";
import ProductPage from "./pages/ProductPage.jsx";
import AdminLogin from "./pages/AdminLogin.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import { I18nProvider } from "./lib/i18n.jsx";
import { AuthProvider } from "./lib/auth.jsx";
import { CustomerProvider } from "./lib/customer.jsx";
import { initAnalytics } from "./lib/analytics.js";

function App() {
  useEffect(() => { initAnalytics(); }, []);
  return (
    <I18nProvider>
      <CustomerProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/productos/:slug" element={<ProductPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot" element={<ForgotPassword />} />
              <Route path="/admin/reset/:token" element={<ResetPassword />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </CustomerProvider>
    </I18nProvider>
  );
}

export default App;
